/**
 * © 2026 iTech India Private Limited. All rights reserved.
 * Licensed under the iTech End User License Agreement (EULA).
 * Unauthorized use or distribution is prohibited.
 */

import { type JSX } from 'react';

import { type AuditEntry } from '../../lib/api/sa.js';
import { formatIst } from '../../lib/utils/datetime.js';

const DASH = '—';
const CELL = 'px-5 py-3 text-slate-600 dark:text-slate-300';

/** One row of the Super Admin → Audit results table. */
export function AuditTableRow({ entry }: { readonly entry: AuditEntry }): JSX.Element {
  return (
    <tr className="hover:bg-slate-50 dark:hover:bg-slate-800/60">
      <td className={CELL}>{formatIst(entry.at, 'dd MMM yyyy, HH:mm')}</td>
      <td className={CELL}>{entry.clinicName ?? DASH}</td>
      <td className={CELL}>{entry.actorType}</td>
      <td className="px-5 py-3 font-medium text-slate-800 dark:text-white">{entry.action}</td>
      <td className={CELL}>{entry.entity ?? DASH}</td>
    </tr>
  );
}
